(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("jwt-decode"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define([, , ], factory);
	else if(typeof exports === 'object')
		exports["VueRvcLogin"] = factory(require("vue"), require("jwt-decode"), require("axios"));
	else
		root["VueRvcLogin"] = factory(root["Vue"], root["jwt_decode"], root["axios"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_b659__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "194d":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "1986":
/***/ (function(module, exports, __webpack_require__) {

!function(n,t){ true?module.exports=t():undefined}(this,function(){return function(n){function t(e){if(a[e])return a[e].exports;var d=a[e]={i:e,l:!1,exports:{}};return n[e].call(d.exports,d,d.exports,t),d.l=!0,d.exports}var a={};return t.m=n,t.c=a,t.i=function(n){return n},t.d=function(n,a,e){t.o(n,a)||Object.defineProperty(n,a,{configurable:!1,enumerable:!0,get:e})},t.n=function(n){var a=n&&n.__esModule?function(){return n.default}:function(){return n};return t.d(a,"a",a),a},t.o=function(n,t){return Object.prototype.hasOwnProperty.call(n,t)},t.p="",t(t.s=2)}([function(n,t,a){a(9);var e=a(7)(a(1),a(8),null,null);e.options.__file="/Users/zhangchaofan/Dev/Temp/vue-ladda/src/vue-ladda.vue",e.esModule&&Object.keys(e.esModule).some(function(n){return"default"!==n&&"__esModule"!==n})&&console.error("named exports are not supported in *.vue files."),e.options.functional&&console.error("[vue-loader] vue-ladda.vue: functional components are not supported with templates, they should use render functions."),n.exports=e.exports},function(n,t,a){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=a(5),d=function(n){return n&&n.__esModule?n:{default:n}}(e);t.default={name:"VueLadda",props:{buttonClass:{type:String,default:"ladda-button"},dataStyle:{type:String,default:"expand-left"},loading:{type:Boolean,required:!0},progress:{validator:function(n){return n>=0&&n<=1},default:0}},watch:{loading:function(n){n?this.ladda.start():this.ladda.stop()},progress:function(n){this.ladda.setProgress(n)}},methods:{handleClick:function(n){this.$emit("click",n)}},mounted:function(){this.ladda=d.default.create(this.$refs.ladda),this.loading?this.ladda.start():this.ladda.stop()},beforeDestroy:function(){this.ladda.remove(),delete this.ladda}}},function(n,t,a){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=a(0),d=function(n){return n&&n.__esModule?n:{default:n}}(e),o={install:function(n,t){n.component("vue-ladda",d.default)}};"undefined"!=typeof window&&window.Vue&&window.Vue.use(o),t.default=d.default},function(n,t,a){t=n.exports=a(4)(!1),t.push([n.i,'/*!\r\n * Ladda including the default theme.\r\n */\n/*!\r\n * Ladda\r\n * http://lab.hakim.se/ladda\r\n * MIT licensed\r\n *\r\n * Copyright (C) 2016 Hakim El Hattab, http://hakim.se\r\n */\n/*************************************\r\n * CONFIG\r\n */\n/*************************************\r\n * MIXINS\r\n */\n/*************************************\r\n * BUTTON BASE\r\n */\n.ladda-button {\n  position: relative;\n}\n\n/* Spinner animation */\n.ladda-button .ladda-spinner {\n  position: absolute;\n  z-index: 2;\n  display: inline-block;\n  width: 32px;\n  top: 50%;\n  margin-top: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Button label */\n.ladda-button .ladda-label {\n  position: relative;\n  z-index: 3;\n}\n\n/* Progress bar */\n.ladda-button .ladda-progress {\n  position: absolute;\n  width: 0;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background: rgba(0, 0, 0, 0.2);\n  display: none;\n  -webkit-transition: 0.1s linear all !important;\n  -moz-transition: 0.1s linear all !important;\n  -ms-transition: 0.1s linear all !important;\n  -o-transition: 0.1s linear all !important;\n  transition: 0.1s linear all !important;\n}\n.ladda-button[data-loading] .ladda-progress {\n  display: block;\n}\n\n/*************************************\r\n * EASING\r\n */\n.ladda-button,\n.ladda-button .ladda-spinner,\n.ladda-button .ladda-label {\n  -webkit-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n  -moz-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n  -ms-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n  -o-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n}\n.ladda-button[data-style=zoom-in],\n.ladda-button[data-style=zoom-in] .ladda-spinner,\n.ladda-button[data-style=zoom-in] .ladda-label,\n.ladda-button[data-style=zoom-out],\n.ladda-button[data-style=zoom-out] .ladda-spinner,\n.ladda-button[data-style=zoom-out] .ladda-label {\n  -webkit-transition: 0.3s ease all !important;\n  -moz-transition: 0.3s ease all !important;\n  -ms-transition: 0.3s ease all !important;\n  -o-transition: 0.3s ease all !important;\n  transition: 0.3s ease all !important;\n}\n\n/*************************************\r\n * EXPAND RIGHT\r\n */\n.ladda-button[data-style=expand-right] .ladda-spinner {\n  right: -6px;\n}\n.ladda-button[data-style=expand-right][data-size="s"] .ladda-spinner,\n.ladda-button[data-style=expand-right][data-size="xs"] .ladda-spinner {\n  right: -12px;\n}\n.ladda-button[data-style=expand-right][data-loading] {\n  padding-right: 56px;\n}\n.ladda-button[data-style=expand-right][data-loading] .ladda-spinner {\n    opacity: 1;\n}\n.ladda-button[data-style=expand-right][data-loading][data-size="s"], .ladda-button[data-style=expand-right][data-loading][data-size="xs"] {\n    padding-right: 40px;\n}\n\n/*************************************\r\n * EXPAND LEFT\r\n */\n.ladda-button[data-style=expand-left] .ladda-spinner {\n  left: 26px;\n}\n.ladda-button[data-style=expand-left][data-size="s"] .ladda-spinner,\n.ladda-button[data-style=expand-left][data-size="xs"] .ladda-spinner {\n  left: 4px;\n}\n.ladda-button[data-style=expand-left][data-loading] {\n  padding-left: 56px;\n}\n.ladda-button[data-style=expand-left][data-loading] .ladda-spinner {\n    opacity: 1;\n}\n.ladda-button[data-style=expand-left][data-loading][data-size="s"], .ladda-button[data-style=expand-left][data-loading][data-size="xs"] {\n    padding-left: 40px;\n}\n\n/*************************************\r\n * EXPAND UP\r\n */\n.ladda-button[data-style=expand-up] {\n  overflow: hidden;\n}\n.ladda-button[data-style=expand-up] .ladda-spinner {\n    top: -32px;\n    left: 50%;\n    margin-left: 0;\n}\n.ladda-button[data-style=expand-up][data-loading] {\n    padding-top: 54px;\n}\n.ladda-button[data-style=expand-up][data-loading] .ladda-spinner {\n      opacity: 1;\n      top: 26px;\n      margin-top: 0;\n}\n.ladda-button[data-style=expand-up][data-loading][data-size="s"], .ladda-button[data-style=expand-up][data-loading][data-size="xs"] {\n      padding-top: 32px;\n}\n.ladda-button[data-style=expand-up][data-loading][data-size="s"] .ladda-spinner, .ladda-button[data-style=expand-up][data-loading][data-size="xs"] .ladda-spinner {\n        top: 4px;\n}\n\n/*************************************\r\n * EXPAND DOWN\r\n */\n.ladda-button[data-style=expand-down] {\n  overflow: hidden;\n}\n.ladda-button[data-style=expand-down] .ladda-spinner {\n    top: 62px;\n    left: 50%;\n    margin-left: 0;\n}\n.ladda-button[data-style=expand-down][data-size="s"] .ladda-spinner,\n  .ladda-button[data-style=expand-down][data-size="xs"] .ladda-spinner {\n    top: 40px;\n}\n.ladda-button[data-style=expand-down][data-loading] {\n    padding-bottom: 54px;\n}\n.ladda-button[data-style=expand-down][data-loading] .ladda-spinner {\n      opacity: 1;\n}\n.ladda-button[data-style=expand-down][data-loading][data-size="s"], .ladda-button[data-style=expand-down][data-loading][data-size="xs"] {\n      padding-bottom: 32px;\n}\n\n/*************************************\r\n * SLIDE LEFT\r\n */\n.ladda-button[data-style=slide-left] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-left] .ladda-label {\n    position: relative;\n}\n.ladda-button[data-style=slide-left] .ladda-spinner {\n    left: 100%;\n    margin-left: 0;\n}\n.ladda-button[data-style=slide-left][data-loading] .ladda-label {\n    opacity: 0;\n    left: -100%;\n}\n.ladda-button[data-style=slide-left][data-loading] .ladda-spinner {\n    opacity: 1;\n    left: 50%;\n}\n\n/*************************************\r\n * SLIDE RIGHT\r\n */\n.ladda-button[data-style=slide-right] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-right] .ladda-label {\n    position: relative;\n}\n.ladda-button[data-style=slide-right] .ladda-spinner {\n    right: 100%;\n    margin-left: 0;\n    left: 16px;\n}\n[dir="rtl"] .ladda-button[data-style=slide-right] .ladda-spinner {\n      right: auto;\n}\n.ladda-button[data-style=slide-right][data-loading] .ladda-label {\n    opacity: 0;\n    left: 100%;\n}\n.ladda-button[data-style=slide-right][data-loading] .ladda-spinner {\n    opacity: 1;\n    left: 50%;\n}\n\n/*************************************\r\n * SLIDE UP\r\n */\n.ladda-button[data-style=slide-up] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-up] .ladda-label {\n    position: relative;\n}\n.ladda-button[data-style=slide-up] .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n    margin-top: 1em;\n}\n.ladda-button[data-style=slide-up][data-loading] .ladda-label {\n    opacity: 0;\n    top: -1em;\n}\n.ladda-button[data-style=slide-up][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-top: 0;\n}\n\n/*************************************\r\n * SLIDE DOWN\r\n */\n.ladda-button[data-style=slide-down] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-down] .ladda-label {\n    position: relative;\n}\n.ladda-button[data-style=slide-down] .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n    margin-top: -2em;\n}\n.ladda-button[data-style=slide-down][data-loading] .ladda-label {\n    opacity: 0;\n    top: 1em;\n}\n.ladda-button[data-style=slide-down][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-top: 0;\n}\n\n/*************************************\r\n * ZOOM-OUT\r\n */\n.ladda-button[data-style=zoom-out] {\n  overflow: hidden;\n}\n.ladda-button[data-style=zoom-out] .ladda-spinner {\n  left: 50%;\n  margin-left: 32px;\n  -webkit-transform: scale(2.5);\n  -moz-transform: scale(2.5);\n  -ms-transform: scale(2.5);\n  -o-transform: scale(2.5);\n  transform: scale(2.5);\n}\n.ladda-button[data-style=zoom-out] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n.ladda-button[data-style=zoom-out][data-loading] .ladda-label {\n  opacity: 0;\n  -webkit-transform: scale(0.5);\n  -moz-transform: scale(0.5);\n  -ms-transform: scale(0.5);\n  -o-transform: scale(0.5);\n  transform: scale(0.5);\n}\n.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n  -webkit-transform: none;\n  -moz-transform: none;\n  -ms-transform: none;\n  -o-transform: none;\n  transform: none;\n}\n\n/*************************************\r\n * ZOOM-IN\r\n */\n.ladda-button[data-style=zoom-in] {\n  overflow: hidden;\n}\n.ladda-button[data-style=zoom-in] .ladda-spinner {\n  left: 50%;\n  margin-left: -16px;\n  -webkit-transform: scale(0.2);\n  -moz-transform: scale(0.2);\n  -ms-transform: scale(0.2);\n  -o-transform: scale(0.2);\n  transform: scale(0.2);\n}\n.ladda-button[data-style=zoom-in] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n.ladda-button[data-style=zoom-in][data-loading] .ladda-label {\n  opacity: 0;\n  -webkit-transform: scale(2.2);\n  -moz-transform: scale(2.2);\n  -ms-transform: scale(2.2);\n  -o-transform: scale(2.2);\n  transform: scale(2.2);\n}\n.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n  -webkit-transform: none;\n  -moz-transform: none;\n  -ms-transform: none;\n  -o-transform: none;\n  transform: none;\n}\n\n/*************************************\r\n * CONTRACT\r\n */\n.ladda-button[data-style=contract] {\n  overflow: hidden;\n  width: 100px;\n}\n.ladda-button[data-style=contract] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n.ladda-button[data-style=contract][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n}\n.ladda-button[data-style=contract][data-loading] .ladda-label {\n  opacity: 0;\n}\n.ladda-button[data-style=contract][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n/*************************************\r\n * OVERLAY\r\n */\n.ladda-button[data-style=contract-overlay] {\n  overflow: hidden;\n  width: 100px;\n  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0);\n}\n.ladda-button[data-style=contract-overlay] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n.ladda-button[data-style=contract-overlay][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/\n  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0.8);\n}\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {\n  opacity: 0;\n}\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n[dir="rtl"] .ladda-spinner > div {\n  left: 25% !important;\n}\n\n/*************************************\r\n * CONFIG\r\n */\n/*************************************\r\n * BUTTON THEME\r\n */\n.ladda-button {\n  background: #666;\n  border: 0;\n  padding: 14px 18px;\n  font-size: 18px;\n  cursor: pointer;\n  color: #fff;\n  border-radius: 2px;\n  border: 1px solid transparent;\n  -webkit-appearance: none;\n  -webkit-font-smoothing: antialiased;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.ladda-button:hover {\n    border-color: rgba(0, 0, 0, 0.07);\n    background-color: #888;\n}\n.ladda-button[data-color=green] {\n    background: #2aca76;\n}\n.ladda-button[data-color=green]:hover {\n      background-color: #38d683;\n}\n.ladda-button[data-color=blue] {\n    background: #53b5e6;\n}\n.ladda-button[data-color=blue]:hover {\n      background-color: #69bfe9;\n}\n.ladda-button[data-color=red] {\n    background: #ea8557;\n}\n.ladda-button[data-color=red]:hover {\n      background-color: #ed956e;\n}\n.ladda-button[data-color=purple] {\n    background: #9973C2;\n}\n.ladda-button[data-color=purple]:hover {\n      background-color: #a685ca;\n}\n.ladda-button[data-color=mint] {\n    background: #16a085;\n}\n.ladda-button[data-color=mint]:hover {\n      background-color: #19b698;\n}\n.ladda-button[disabled], .ladda-button[data-loading] {\n    border-color: rgba(0, 0, 0, 0.07);\n}\n.ladda-button[disabled], .ladda-button[disabled]:hover, .ladda-button[data-loading], .ladda-button[data-loading]:hover {\n      cursor: default;\n      background-color: #999;\n}\n.ladda-button[data-size=xs] {\n    padding: 4px 8px;\n}\n.ladda-button[data-size=xs] .ladda-label {\n      font-size: 0.7em;\n}\n.ladda-button[data-size=s] {\n    padding: 6px 10px;\n}\n.ladda-button[data-size=s] .ladda-label {\n      font-size: 0.9em;\n}\n.ladda-button[data-size=l] .ladda-label {\n    font-size: 1.2em;\n}\n.ladda-button[data-size=xl] .ladda-label {\n    font-size: 1.5em;\n}\n',""])},function(n,t){function a(n,t){var a=n[1]||"",d=n[3];if(!d)return a;if(t&&"function"==typeof btoa){var o=e(d);return[a].concat(d.sources.map(function(n){return"/*# sourceURL="+d.sourceRoot+n+" */"})).concat([o]).join("\n")}return[a].join("\n")}function e(n){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(n))))+" */"}n.exports=function(n){var t=[];return t.toString=function(){return this.map(function(t){var e=a(t,n);return t[2]?"@media "+t[2]+"{"+e+"}":e}).join("")},t.i=function(n,a){"string"==typeof n&&(n=[[null,n,""]]);for(var e={},d=0;d<this.length;d++){var o=this[d][0];"number"==typeof o&&(e[o]=!0)}for(d=0;d<n.length;d++){var r=n[d];"number"==typeof r[0]&&e[r[0]]||(a&&!r[2]?r[2]=a:a&&(r[2]="("+r[2]+") and ("+a+")"),t.push(r))}},t}},function(n,t,a){/*!
 * Ladda
 * http://lab.hakim.se/ladda
 * MIT licensed
 *
 * Copyright (C) 2016 Hakim El Hattab, http://hakim.se
 */
!function(t,e){"use strict";n.exports=e(a(6))}(0,function(n){"use strict";function t(n){if(void 0===n)return void console.warn("Ladda button target must be defined.");if(/ladda-button/i.test(n.className)||(n.className+=" ladda-button"),n.hasAttribute("data-style")||n.setAttribute("data-style","expand-right"),!n.querySelector(".ladda-label")){var t=document.createElement("span");t.className="ladda-label",i(n,t)}var a,e=n.querySelector(".ladda-spinner");e||(e=document.createElement("span"),e.className="ladda-spinner"),n.appendChild(e);var d,o={start:function(){return a||(a=r(n)),n.disabled=!0,n.setAttribute("data-loading",""),clearTimeout(d),a.spin(e),this.setProgress(0),this},startAfter:function(n){return clearTimeout(d),d=setTimeout(function(){o.start()},n),this},stop:function(){return o.isLoading()&&(n.disabled=!1,n.removeAttribute("data-loading")),clearTimeout(d),a&&(d=setTimeout(function(){a.stop()},1e3)),this},toggle:function(){return this.isLoading()?this.stop():this.start()},setProgress:function(t){t=Math.max(Math.min(t,1),0);var a=n.querySelector(".ladda-progress");0===t&&a&&a.parentNode?a.parentNode.removeChild(a):(a||(a=document.createElement("div"),a.className="ladda-progress",n.appendChild(a)),a.style.width=(t||0)*n.offsetWidth+"px")},enable:function(){return this.stop()},disable:function(){return this.stop(),n.disabled=!0,this},isLoading:function(){return n.hasAttribute("data-loading")},remove:function(){clearTimeout(d),n.disabled=!1,n.removeAttribute("data-loading"),a&&(a.stop(),a=null),s.splice(s.indexOf(o),1)}};return s.push(o),o}function a(n,t){for(;n.parentNode&&n.tagName!==t;)n=n.parentNode;return t===n.tagName?n:void 0}function e(n){var t=["input","textarea","select"],a=[];return t.forEach(function(t){for(var e=n.getElementsByTagName(t),d=0;d<e.length;d++)e[d].hasAttribute("required")&&a.push(e[d])}),a}function d(n,t){var a;if("string"==typeof n)a=document.querySelectorAll(n);else{if("object"!=typeof n)throw new Error("target must be string or object");a=[n]}t=t||{};for(var e=0;e<a.length;e++)l(a[e],t)}function o(){for(var n=0,t=s.length;n<t;n++)s[n].stop()}function r(t){var a,e,d=t.offsetHeight;0===d&&(d=parseFloat(window.getComputedStyle(t).height)),d>32&&(d*=.8),t.hasAttribute("data-spinner-size")&&(d=parseInt(t.getAttribute("data-spinner-size"),10)),t.hasAttribute("data-spinner-color")&&(a=t.getAttribute("data-spinner-color")),t.hasAttribute("data-spinner-lines")&&(e=parseInt(t.getAttribute("data-spinner-lines"),10));var o=.2*d,r=.6*o,i=o<7?2:3;return new n({color:a||"#fff",lines:e||12,radius:o,length:r,width:i,zIndex:"auto",top:"auto",left:"auto",className:""})}function i(n,t){var a=document.createRange();a.selectNodeContents(n),a.surroundContents(t),n.appendChild(t)}function l(n,d){if("function"==typeof n.addEventListener){var o=t(n),r=-1;n.addEventListener("click",function(){var t=!0,i=a(n,"FORM");if(void 0!==i&&!i.hasAttribute("novalidate"))if("function"==typeof i.checkValidity)t=i.checkValidity();else for(var l=e(i),s=0;s<l.length;s++){var u=l[s],p=u.getAttribute("type");if(""===u.value.replace(/^\s+|\s+$/g,"")&&(t=!1),"checkbox"!==p&&"radio"!==p||u.checked||(t=!1),"email"===p&&(t=/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/i.test(u.value)),"url"===p&&(t=/^([a-z]([a-z]|\d|\+|-|\.)*):(\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?((\[(|(v[\da-f]{1,}\.(([a-z]|\d|-|\.|_|~)|[!\$&'\(\)\*\+,;=]|:)+))\])|((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=])*)(:\d*)?)(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*|(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)){0})(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(u.value)),!t)break}t&&(o.startAfter(1),"number"==typeof d.timeout&&(clearTimeout(r),r=setTimeout(o.stop,d.timeout)),"function"==typeof d.callback&&d.callback.apply(null,[o]))},!1)}}var s=[];return{bind:d,create:t,stopAll:o}})},function(n,t,a){var e,d;!function(o,r){"object"==typeof n&&n.exports?n.exports=r():(e=r,void 0!==(d="function"==typeof e?e.call(t,a,t,n):e)&&(n.exports=d))}(0,function(){"use strict";function n(n,t){var a,e=document.createElement(n||"div");for(a in t)e[a]=t[a];return e}function t(n){for(var t=1,a=arguments.length;t<a;t++)n.appendChild(arguments[t]);return n}function a(n,t,a,e){var d=["opacity",t,~~(100*n),a,e].join("-"),o=.01+a/e*100,r=Math.max(1-(1-n)/t*(100-o),n),i=l.substring(0,l.indexOf("Animation")).toLowerCase(),u=i&&"-"+i+"-"||"";return p[d]||(s.insertRule("@"+u+"keyframes "+d+"{0%{opacity:"+r+"}"+o+"%{opacity:"+n+"}"+(o+.01)+"%{opacity:1}"+(o+t)%100+"%{opacity:"+n+"}100%{opacity:"+r+"}}",s.cssRules.length),p[d]=1),d}function e(n,t){var a,e,d=n.style;if(t=t.charAt(0).toUpperCase()+t.slice(1),void 0!==d[t])return t;for(e=0;e<u.length;e++)if(a=u[e]+t,void 0!==d[a])return a}function d(n,t){for(var a in t)n.style[e(n,a)||a]=t[a];return n}function o(n){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var e in a)void 0===n[e]&&(n[e]=a[e])}return n}function r(n,t){return"string"==typeof n?n:n[t%n.length]}function i(n){this.opts=o(n||{},i.defaults,c)}var l,s,u=["webkit","Moz","ms","O"],p={},c={lines:12,length:7,width:5,radius:10,scale:1,corners:1,color:"#000",opacity:.25,rotate:0,direction:1,speed:1,trail:100,fps:20,zIndex:2e9,className:"spinner",top:"50%",left:"50%",shadow:!1,hwaccel:!1,position:"absolute"};if(i.defaults={},o(i.prototype,{spin:function(t){this.stop();var a=this,e=a.opts,o=a.el=n(null,{className:e.className});if(d(o,{position:e.position,width:0,zIndex:e.zIndex,left:e.left,top:e.top}),t&&t.insertBefore(o,t.firstChild||null),o.setAttribute("role","progressbar"),a.lines(o,a.opts),!l){var r,i=0,s=(e.lines-1)*(1-e.direction)/2,u=e.fps,p=u/e.speed,c=(1-e.opacity)/(p*e.trail/100),f=p/e.lines;!function n(){i++;for(var t=0;t<e.lines;t++)r=Math.max(1-(i+(e.lines-t)*f)%p*c,e.opacity),a.opacity(o,t*e.direction+s,r,e);a.timeout=a.el&&setTimeout(n,~~(1e3/u))}()}return a},stop:function(){var n=this.el;return n&&(clearTimeout(this.timeout),n.parentNode&&n.parentNode.removeChild(n),this.el=void 0),this},lines:function(e,o){function i(t,a){return d(n(),{position:"absolute",width:o.scale*(o.length+o.width)+"px",height:o.scale*o.width+"px",background:t,boxShadow:a,transformOrigin:"left",transform:"rotate("+~~(360/o.lines*u+o.rotate)+"deg) translate("+o.scale*o.radius+"px,0)",borderRadius:(o.corners*o.scale*o.width>>1)+"px"})}for(var s,u=0,p=(o.lines-1)*(1-o.direction)/2;u<o.lines;u++)s=d(n(),{position:"absolute",top:1+~(o.scale*o.width/2)+"px",transform:o.hwaccel?"translate3d(0,0,0)":"",opacity:o.opacity,animation:l&&a(o.opacity,o.trail,p+u*o.direction,o.lines)+" "+1/o.speed+"s linear infinite"}),o.shadow&&t(s,d(i("#000","0 0 4px #000"),{top:"2px"})),t(e,t(s,i(r(o.color,u),"0 0 1px rgba(0,0,0,.1)")));return e},opacity:function(n,t,a){t<n.childNodes.length&&(n.childNodes[t].style.opacity=a)}}),"undefined"!=typeof document){s=function(){var a=n("style",{type:"text/css"});return t(document.getElementsByTagName("head")[0],a),a.sheet||a.styleSheet}();var f=d(n("group"),{behavior:"url(#default#VML)"});!e(f,"transform")&&f.adj?function(){function a(t,a){return n("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">',a)}s.addRule(".spin-vml","behavior:url(#default#VML)"),i.prototype.lines=function(n,e){function o(){return d(a("group",{coordsize:u+" "+u,coordorigin:-s+" "+-s}),{width:u,height:u})}function i(n,i,l){t(c,t(d(o(),{rotation:360/e.lines*n+"deg",left:~~i}),t(d(a("roundrect",{arcsize:e.corners}),{width:s,height:e.scale*e.width,left:e.scale*e.radius,top:-e.scale*e.width>>1,filter:l}),a("fill",{color:r(e.color,n),opacity:e.opacity}),a("stroke",{opacity:0}))))}var l,s=e.scale*(e.length+e.width),u=2*e.scale*s,p=-(e.width+e.length)*e.scale*2+"px",c=d(o(),{position:"absolute",top:p,left:p});if(e.shadow)for(l=1;l<=e.lines;l++)i(l,-2,"progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");for(l=1;l<=e.lines;l++)i(l);return t(n,c)},i.prototype.opacity=function(n,t,a,e){var d=n.firstChild;e=e.shadow&&e.lines||0,d&&t+e<d.childNodes.length&&(d=d.childNodes[t+e],d=d&&d.firstChild,(d=d&&d.firstChild)&&(d.opacity=a))}}():l=e(f,"animation")}return i})},function(n,t){n.exports=function(n,t,a,e){var d,o=n=n||{},r=typeof n.default;"object"!==r&&"function"!==r||(d=n,o=n.default);var i="function"==typeof o?o.options:o;if(t&&(i.render=t.render,i.staticRenderFns=t.staticRenderFns),a&&(i._scopeId=a),e){var l=Object.create(i.computed||null);Object.keys(e).forEach(function(n){var t=e[n];l[n]=function(){return t}}),i.computed=l}return{esModule:d,exports:o,options:i}}},function(n,t,a){n.exports={render:function(){var n=this,t=n.$createElement,a=n._self._c||t;return a("button",{ref:"ladda",class:n.buttonClass,attrs:{"data-style":n.dataStyle},on:{click:n.handleClick}},[n._t("default",[a("span",{staticClass:"ladda-label"},[n._v("Submit")])])],2)},staticRenderFns:[]},n.exports.render._withStripped=!0},function(n,t,a){var e=a(3);"string"==typeof e&&(e=[[n.i,e,""]]),e.locals&&(n.exports=e.locals);a(10)("e5cb09de",e,!1)},function(n,t,a){function e(n){for(var t=0;t<n.length;t++){var a=n[t],e=u[a.id];if(e){e.refs++;for(var d=0;d<e.parts.length;d++)e.parts[d](a.parts[d]);for(;d<a.parts.length;d++)e.parts.push(o(a.parts[d]));e.parts.length>a.parts.length&&(e.parts.length=a.parts.length)}else{for(var r=[],d=0;d<a.parts.length;d++)r.push(o(a.parts[d]));u[a.id]={id:a.id,refs:1,parts:r}}}}function d(){var n=document.createElement("style");return n.type="text/css",p.appendChild(n),n}function o(n){var t,a,e=document.querySelector('style[data-vue-ssr-id~="'+n.id+'"]');if(e){if(b)return m;e.parentNode.removeChild(e)}if(h){var o=f++;e=c||(c=d()),t=r.bind(null,e,o,!1),a=r.bind(null,e,o,!0)}else e=d(),t=i.bind(null,e),a=function(){e.parentNode.removeChild(e)};return t(n),function(e){if(e){if(e.css===n.css&&e.media===n.media&&e.sourceMap===n.sourceMap)return;t(n=e)}else a()}}function r(n,t,a,e){var d=a?"":e.css;if(n.styleSheet)n.styleSheet.cssText=g(t,d);else{var o=document.createTextNode(d),r=n.childNodes;r[t]&&n.removeChild(r[t]),r.length?n.insertBefore(o,r[t]):n.appendChild(o)}}function i(n,t){var a=t.css,e=t.media,d=t.sourceMap;if(e&&n.setAttribute("media",e),d&&(a+="\n/*# sourceURL="+d.sources[0]+" */",a+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(d))))+" */"),n.styleSheet)n.styleSheet.cssText=a;else{for(;n.firstChild;)n.removeChild(n.firstChild);n.appendChild(document.createTextNode(a))}}var l="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!l)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var s=a(11),u={},p=l&&(document.head||document.getElementsByTagName("head")[0]),c=null,f=0,b=!1,m=function(){},h="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());n.exports=function(n,t,a){b=a;var d=s(n,t);return e(d),function(t){for(var a=[],o=0;o<d.length;o++){var r=d[o],i=u[r.id];i.refs--,a.push(i)}t?(d=s(n,t),e(d)):d=[];for(var o=0;o<a.length;o++){var i=a[o];if(0===i.refs){for(var l=0;l<i.parts.length;l++)i.parts[l]();delete u[i.id]}}}};var g=function(){var n=[];return function(t,a){return n[t]=a,n.filter(Boolean).join("\n")}}()},function(n,t){n.exports=function(n,t){for(var a=[],e={},d=0;d<t.length;d++){var o=t[d],r=o[0],i=o[1],l=o[2],s=o[3],u={id:n+":"+d,css:i,media:l,sourceMap:s};e[r]?e[r].parts.push(u):a.push(e[r]={id:r,parts:[u]})}return a}}])});

/***/ }),

/***/ "1eb5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".sr-only[data-v-349e059c]{display:none}form[data-v-349e059c]{text-align:center;background-color:#fff;max-width:320px;margin:0 auto}h3[data-v-349e059c]{font-size:25px;margin-bottom:10px}p[data-v-349e059c]{margin:0 0 12px}input[data-v-349e059c],p[data-v-349e059c]{font-size:14px}input[data-v-349e059c]{display:block;width:100%;height:30px;border:1px solid #ccc;border-radius:4px;background-color:#fff;padding:5px 10px;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);margin:10px 0}.err[data-v-349e059c]{color:maroon;font-style:italic;margin-bottom:8px}.standardLogin button[data-v-349e059c]{width:100%}.autoLogin button[data-v-349e059c]{display:inline-block;width:32%;margin:10px 8%}.autologinname[data-v-349e059c]{font-size:22px;font-weight:700;text-align:center;margin:14px}", ""]);

// exports


/***/ }),

/***/ "2350":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "2620":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_src_index_js_ref_6_oneOf_1_2_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_vue_loader_lib_index_js_vue_loader_options_VueRvcLogin_vue_vue_type_style_index_0_id_349e059c_lang_css_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c39c");
/* harmony import */ var _vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_src_index_js_ref_6_oneOf_1_2_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_vue_loader_lib_index_js_vue_loader_options_VueRvcLogin_vue_vue_type_style_index_0_id_349e059c_lang_css_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_src_index_js_ref_6_oneOf_1_2_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_vue_loader_lib_index_js_vue_loader_options_VueRvcLogin_vue_vue_type_style_index_0_id_349e059c_lang_css_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "b659":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_b659__;

/***/ }),

/***/ "c39c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1eb5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("cbfc").default
var update = add("fcf2d2c6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "cbfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ../vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ../vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "cebe":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_cebe__;

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "VueRvcLogin", function() { return /* reexport */ VueRvcLogin; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("194d")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ../cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"70f8791b-vue-loader-template"}!../vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!../vue-loader/lib??vue-loader-options!./src/VueRvcLogin.vue?vue&type=template&id=349e059c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h3',[_vm._v("\n        Please sign in\n    ")]),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.err.length),expression:"err.length"}],staticClass:"err"},[_vm._v("\n        "+_vm._s(_vm.err)+"\n    ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.autologin===false),expression:"autologin===false"}],staticClass:"standardLogin"},[_c('p',[_vm._v("\n            Please enter your name or ID, and your password.\n        ")]),_c('label',{staticClass:"sr-only",attrs:{"for":"inputID"}},[_vm._v("ID")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.id),expression:"id"}],ref:"id",attrs:{"type":"text","id":"inputID","placeholder":"Name or ID"},domProps:{"value":(_vm.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.id=$event.target.value}}}),_c('label',{staticClass:"sr-only",attrs:{"for":"inputPassword"}},[_vm._v("Password")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","id":"inputPassword","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_c('vue-ladda',{attrs:{"type":"submit","loading":_vm.loading,"data-style":"slide-right","data-color":"blue"}},[_vm._v("Sign in")])],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.autologin===true),expression:"autologin===true"}],staticClass:"autoLogin"},[_c('p',[_vm._v("\n            You are logged into the site as:\n        ")]),_c('div',{staticClass:"autologinname"},[_vm._v("\n            "+_vm._s(_vm.userFullName)+" ("+_vm._s(_vm.userFullId)+")\n        ")]),_c('p',[_vm._v("\n            Do you want to log into the "+_vm._s(_vm.appName)+" application as this person?\n        ")]),_c('vue-ladda',{ref:"yes",attrs:{"type":"submit","loading":_vm.loading,"data-style":"slide-right","data-color":"blue"}},[_vm._v("Yes")]),_c('vue-ladda',{attrs:{"type":"button","loading":false,"data-color":"red"},on:{"click":_vm.dismissAutologin}},[_vm._v("No")])],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/VueRvcLogin.vue?vue&type=template&id=349e059c&scoped=true&

// EXTERNAL MODULE: ../vue-ladda/dist/vue-ladda.js
var vue_ladda = __webpack_require__("1986");
var vue_ladda_default = /*#__PURE__*/__webpack_require__.n(vue_ladda);

// EXTERNAL MODULE: external {"commonjs":"axios","commonjs2":"axios","root":"axios"}
var external_commonjs_axios_commonjs2_axios_root_axios_ = __webpack_require__("cebe");
var external_commonjs_axios_commonjs2_axios_root_axios_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_axios_commonjs2_axios_root_axios_);

// EXTERNAL MODULE: external {"commonjs":"jwt-decode","commonjs2":"jwt-decode","root":"jwt_decode"}
var external_commonjs_jwt_decode_commonjs2_jwt_decode_root_jwt_decode_ = __webpack_require__("b659");
var external_commonjs_jwt_decode_commonjs2_jwt_decode_root_jwt_decode_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_jwt_decode_commonjs2_jwt_decode_root_jwt_decode_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!../thread-loader/dist/cjs.js!../babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!../vue-loader/lib??vue-loader-options!./src/VueRvcLogin.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var DEFAULTUSER = {
  'id': '',
  'fname': '',
  'lname': '',
  'nickname': '',
  'usertype': ''
};
/* harmony default export */ var VueRvcLoginvue_type_script_lang_js_ = ({
  name: 'VueRvcLogin',
  components: {
    VueLadda: vue_ladda_default.a
  },
  data: function data() {
    return {
      autologinJwt: null,
      err: '',
      id: '',
      loading: false,
      password: ''
    };
  },
  props: {
    appName: {
      type: String,
      default: 'current'
    },
    apiEndpoint: {
      type: String,
      required: true
    }
  },
  computed: {
    /**
     * Returns whether we are in autologin mode (true/false), or null if we don't know yet (autologinJwt hasn't been set yet).
     */
    autologin: function autologin() {
      if (this.autologinJwt === null) return null;else return this.autologinJwt.length > 0;
    },

    /**
     * Returns a user object, either the one provided by the autologinJwt or the default empty one.
     */
    user: function user() {
      var payload;

      try {
        payload = external_commonjs_jwt_decode_commonjs2_jwt_decode_root_jwt_decode_default()(this.autologinJwt);
      } catch (err) {}

      if (!payload) payload = {};
      return Object.assign(DEFAULTUSER, payload);
    },

    /**
     * Returns the full User ID of a user (combining usertype and id)
     */
    userFullId: function userFullId() {
      return (this.user.usertype + this.user.id).trim().toLowerCase();
    },

    /**
     * Returns the full name of the user, utilizing its fname, nickname, and lname properties.
     */
    userFullName: function userFullName() {
      return ((this.user.nickname ? this.user.nickname : this.user.fname) + ' ' + this.user.lname).trim();
    }
  },
  methods: {
    /**
     * Login handler. Checks with the API endpoint and emits "login" event if successful.
     */
    login: function login() {
      var _this = this;

      // "data" will be passed in the POST call. At least pass in the method call "autologin"/"login".
      var data = {
        'method': this.autologin ? 'autologin' : 'login'
      }; // "headers" will be passed in the POST call.

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };

      if (this.autologin) {
        // Autologin method will pass the JWT we have via the headers.
        headers['Authorization'] = 'Bearer ' + this.autologinJwt;
      } else {
        // Normal login method will pass id/password the old fashioned way.
        data['id'] = this.id;
        data['password'] = this.password;
      } // Lightweight client-side validation. Don't strictly look for valid ID so they can lookup with name.


      this.err = '';
      if ('password' in data && data.password.length < 6) this.err = 'Please fully enter your password.';
      if ('id' in data && data.id.length < 6) this.err = 'Please fully enter your name or ID.';

      if (!this.err.length) {
        // Make POST call
        this.loading = true;
        var dataString = Object.keys(data).map(function (k) {
          return k + '=' + encodeURIComponent(data[k]);
        }).join('&');
        external_commonjs_axios_commonjs2_axios_root_axios_default()({
          url: this.apiEndpoint,
          method: 'post',
          headers: headers,
          data: dataString
        }).then(function (response) {
          if (response.data.success) {
            // Emit the "success" event along with received data.
            _this.err = '';
            _this.id = '';
            _this.password = '';

            _this.$emit('success', response.data);
          } else {
            // Received successful transmission but has falsy "success" flag. Use custom "message" if provided, otherwise pass a generic one.
            if (response.data.message) _this.err = response.data.message;else _this.err = _this.autologin ? 'Login failed. Please try again.' : 'Your user ID and password do not match.';
          }
        }).catch(function (error) {
          // Things exploded, pass the error message.
          _this.err = error.response.statusText;
        }).finally(function () {
          // We're done here. If there was an error, emit the "fail" event.
          _this.loading = false;
          if (_this.err.length) _this.$emit('fail', _this.err);
        });
      }
    },

    /**
     * Handles when user clicks "No" on autologin screen, to switch to manual login.
     */
    dismissAutologin: function dismissAutologin() {
      var _this2 = this;

      this.id = '';
      this.password = '';
      this.err = '';
      this.autologinJwt = '';
      this.$nextTick(function () {
        _this2.$refs.id.focus();
      });
    }
  },
  created: function created() {
    var now = new Date().getTime() / 1000; // Matches Unix Epoch format, used by exp/nbf claims

    var localjwt = (localStorage.identity ? localStorage.identity : '').trim(); // Decode the payload. If it is empty/bogus, we'll have an empty object.

    var payload;

    try {
      payload = external_commonjs_jwt_decode_commonjs2_jwt_decode_root_jwt_decode_default()(localjwt);
    } catch (err) {}

    if (!payload) payload = {}; // Check the exp and nbf claims. If all is well, set autologinJwt! Otherwise, it should be empty string.

    if (payload.exp && now > payload.exp || payload.nbf && now < payload.nbf) this.autologinJwt = '';else this.autologinJwt = localjwt;
  },
  mounted: function mounted() {
    this.$refs.yes.$el.focus();
  }
});
// CONCATENATED MODULE: ./src/VueRvcLogin.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_VueRvcLoginvue_type_script_lang_js_ = (VueRvcLoginvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/VueRvcLogin.vue?vue&type=style&index=0&id=349e059c&lang=css&scoped=true&
var VueRvcLoginvue_type_style_index_0_id_349e059c_lang_css_scoped_true_ = __webpack_require__("2620");

// CONCATENATED MODULE: ../vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/VueRvcLogin.vue






/* normalize component */

var component = normalizeComponent(
  src_VueRvcLoginvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "349e059c",
  null
  
)

/* harmony default export */ var VueRvcLogin = (component.exports);
// CONCATENATED MODULE: ./src/index.js



function install (Vue, options) {
    if (!options) options = {};
    Vue.component(options.VueRvcLoginName || 'VueRvcLogin', VueRvcLogin);
}

if (typeof window !== 'undefined' && window.Vue && window.Vue === external_commonjs_vue_commonjs2_vue_root_Vue_default.a) {
    install(window.Vue);
}

/* harmony default export */ var src = (install);



// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);



/***/ })

/******/ });
});
//# sourceMappingURL=VueRvcLogin.umd.js.map